import React from 'react';
import './Hero.css';

/**
 * O título é dividido em palavras para a entrada escalonada.
 * Palavra inteira, nunca letra: quebrar por letra atrapalha leitores de tela
 * e a seleção de texto. `accent` marca as duas palavras que carregam a
 * proposta de valor — são elas que acendem no gradiente.
 */
const TITLE_WORDS: ReadonlyArray<{ text: string; accent?: string }> = [
  { text: 'Sua' },
  { text: 'operação' },
  { text: 'mais' },
  { text: 'simples' },
  { text: 'com' },
  { text: 'tecnologia', accent: 'highlight-purple' },
  { text: 'e' },
  { text: 'inovação', accent: 'highlight-blue' }
];

const Hero: React.FC = () => {
  const handleCtaClick = () => {
    const message = encodeURIComponent(
      'Olá! Vim pelo site da UpdateCommit e gostaria de conversar sobre meu projeto.'
    );
    window.open(`https://wa.me/5521936185311?text=${message}`, '_blank', 'noopener,noreferrer');
  };

  const handleSecondaryClick = () => {
    const servicesSection = document.querySelector('.services-section, #services');
    if (servicesSection) {
      servicesSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  // Items de prova social
  const socialProofItems = [
    {
      icon: (
        <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" className="social-proof-icon">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      ),
      text: "100+ evoluções versionadas"
    },
    {
      icon: (
        <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" className="social-proof-icon">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4" />
        </svg>
      ),
      text: "Código limpo e escalável"
    },
    {
      icon: (
        <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" className="social-proof-icon">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
        </svg>
      ),
      text: "Parceria verdadeira"
    }
  ];

  return (
    <section className="hero-section">
      <div className="hero-content">
        {/* Badge */}
        <div className="hero-badge">
          <span>Estratégia, software e automação em um só parceiro</span>
        </div>

        {/* Título — momento assinatura da página. Cada palavra sobe em
            sequência e, quando o título assenta, as duas palavras de valor
            acendem: o branco some e revela o gradiente que já está atrás. */}
        <h1 className="hero-title">
          {TITLE_WORDS.map((word, index) => (
            <React.Fragment key={word.text}>
              <span
                className={`hero-word${word.accent ? ` ${word.accent} hero-word--ignite` : ''}`}
                style={{ '--i': index } as React.CSSProperties}
              >
                {word.text}
              </span>
              {index < TITLE_WORDS.length - 1 && ' '}
            </React.Fragment>
          ))}
        </h1>

        {/* Subtítulo */}
        <p className="hero-subtitle">
          Criamos produtos digitais, integrações e automações sob medida para transformar
          processos complexos em experiências simples, seguras e prontas para escalar.
        </p>

        {/* Botões de ação */}
        <div className="hero-buttons">
          <button 
            className="cta-button" 
            onClick={handleCtaClick}
            aria-label="Iniciar conversa"
          >
            Falar sobre meu projeto
          </button>
          
          <button 
            className="secondary-button" 
            onClick={handleSecondaryClick}
            aria-label="Conhecer soluções"
          >
            Explorar soluções
          </button>
        </div>

        {/* Carrossel infinito de prova social */}
        <div className="hero-social-proof">
          {/* Não é mais marquee: styles/professional.css fixa este bloco como
              grid estático de 3 colunas (animation: none). Uma rodada de itens. */}
          <div className="social-proof-carousel">
            {socialProofItems.map((item, index) => (
              <div key={`first-${index}`} className="social-proof-item">
                {item.icon}
                <span className="social-proof-text">{item.text}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
